export const OPENBET_SUPPORTED_LOCALES = ['en-ca', 'en-ie', 'pl', 'zh-hk', 'zh-cn', 'es-es'];
export const LANGUAGE_ITEM_CLICKED = 'wh.sports.event.ui.header.language-item.clicked';
export const FEATURE_TYPE = '@sportsbook/languages';
export const LANGUAGE_SELECTED = 'wh.common.event.ui.header.language.selected';
